import getDeviceType from './GetDeviceType';

/*
	W przypadku wyłapania błędu przez Vue, wyślij go do serwera poprzez wywołanie endpointa '/common/util/jscripterror.ofer'
	oraz wyświetl błąd w konsoli. Dodatkowo, uzupełnij wiadomość o typ urządzenia oraz ID sesji.
*/

const sendError = (url?: string, line?: number, msg: string, error?: Error) => {
	// Wysyła informacje o błędzie do Kibany.
	const formData = new FormData();
	formData.append('href', window.location.href);
	formData.append('url', url || window.location.href);
	formData.append('line', String(line || 0));

	const sessionId = '';
	let msgFull = `[App] ${getDeviceType(true)} ${msg} ${sessionId}`;

	if (error) {
		// Jeżeli dostepny jest obiekt błędu, to dodajemy jego szczegóły.
		msgFull += ` | Error message [${error.message || error.toString()}]`;
		msgFull += ` | Stack trace [${error.stack || ''}]`;
	} else {
		// Jeśli nie ma błędu, to dodajemy informację o tym, że nie został przekazany.
		msgFull += ' | Error message [No error object provided]';
		msgFull += ' | Stack trace [No stack trace available]';
	}
	formData.append('msg', msgFull);

	fetch('/common/util/jscripterror.ofer', {
		method: 'POST',
		mode: 'no-cors',
		credentials: 'include',
		body: formData,
	});
};

const errorHandler = (
	msg: string,
	url: string,
	line?: number,
	error?: Error,
) => {
	if (msg.indexOf('NS_ERROR_STORAGE_CONSTRAINT') > -1 && navigator.userAgent.indexOf('Firefox') > -1) {
		// Firefox posiada buga: https://bugzilla.mozilla.org/show_bug.cgi?id=1758416
		// Kiedyś próbowaliśmy to naprawić poprzeć localStorage.clear(), ale to też się nie uda, więc zlewamy temat.
		return;
	}

	const needsReload = msg.indexOf('dynamically imported module') > -1 || msg.indexOf('] []') > -1 || msg.indexOf('[Vue:13] ') > -1 || msg.indexOf('Cannot find module') > -1;
	if (needsReload) {
		// Failed to fetch dynamically imported module:
		// W przypadku napotkania błędu związanego z niemożnością załadowania modułu, spróbuj odświeżyć stronę.
		// Możliwe, że kolejne wczytanie strony rozwiąże problem z wyświetleniem "białej strony".

		// Nie wyłapuje to wszystkich możliwości, dlatego też jeszcze zasadzamy się na: `[Vue:13]`
		// - tak wychodzi z logów Kibany, chociaż może zdarzyć się sytuacja, że będzie to już za dużo.

		window.setTimeout(() => {
			sendError(url, line, 'Module import failed: trying to reload.', error);

			// Używaliśmy `window.location.reload(true);`, ale wtedy nadal nie mamy pewności, że nie zostanie
			// pobrana wersja z cache, dlatego też będziemy dodawać parametr z aktualną datą.
			let { href } = window.location;
			href += (href.indexOf('?') > -1) ? '&' : '?';
			href += `refreshDate=${Number(new Date())}`;
			document.location.replace(href);
		}, 750);
	}

	sendError(url, line, msg, error);
	console.warn(`😢 ${msg}`, error);
};

export default errorHandler;
